import { z } from "zod";

export const ShippingInquirySchema = z.object({
  name: z.string().min(2).max(50),
  email: z.string().email(),
  message: z.string().min(10).max(500),
});

export type ShippingInquiry = z.infer<typeof ShippingInquirySchema>;
